import { styled } from '@mui/material';
import { ReactComponent as IconLamp } from '../../../assets/images/lamp.svg';

export const StyledIconLamp = styled(IconLamp)(({ theme }) => ({
  height: '124px',
  width: '124px',
  color: theme.palette.primary.main,
}));
